import React from 'react'
import { Page } from '../../components/imports'

const Cookies = () => {
  return (
    <Page offset>
      <div className='resp'>

        <h1>
          Resources
        </h1>
      </div>
    </Page>
  )
}

export default Cookies